/**
 * Native Facetten: Section Rendering statt Client-Raster.
 *
 * Der am 09.08.2026 stillgelegte nediso-filter.js hat /products.json geladen
 * und Dawn-Markup ohne CSS gebaut. Hier bleibt die Produktkarte in Liquid.
 * Aendert sich eine Facette, holt dieses Skript die ganze Collection-Sektion
 * neu und tauscht nur den Layout-Block.
 */
(function () {
  var ROOT = '[data-nd-collection]';
  var DEBOUNCE_MS = 280;
  var timer = null;
  var controller = null;
  var requestId = 0;

  function prepareFilters(keepOpen) {
    var drawer = document.querySelector('[data-nd-filter-toggle]');
    if (drawer) drawer.open = typeof keepOpen === 'boolean' ? keepOpen : window.matchMedia('(min-width: 900px)').matches;
  }

  function sectionUrl(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var params = new URLSearchParams(new FormData(form));
    params.set('section_id', form.getAttribute('data-section-id'));
    return action + '?' + params.toString();
  }

  function publicUrl(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var params = new URLSearchParams(new FormData(form));
    return action + (params.toString() ? '?' + params.toString() : '');
  }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector(ROOT);
    var cur = document.querySelector(ROOT);
    if (!next || !cur) return false;
    var previousDrawer = cur.querySelector('[data-nd-filter-toggle]');
    var previousOpen = previousDrawer ? previousDrawer.open : undefined;
    cur.replaceWith(next);
    prepareFilters(previousOpen);
    return true;
  }

  function apply(form) {
    if (controller) controller.abort();
    controller = new AbortController();
    var currentRequest = ++requestId;
    var url = sectionUrl(form);
    var pub = publicUrl(form);
    document.documentElement.classList.add('nd-facets-loading');
    document.documentElement.setAttribute('aria-busy', 'true');
    fetch(url, { credentials: 'same-origin', signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (currentRequest !== requestId) return;
        if (!swap(html)) {
          window.location.href = pub;
          return;
        }
        history.pushState({ ndFacets: true }, '', pub);
      })
      .catch(function (error) {
        if (error.name === 'AbortError' || currentRequest !== requestId) return;
        window.location.href = pub;
      })
      .finally(function () {
        if (currentRequest !== requestId) return;
        document.documentElement.classList.remove('nd-facets-loading');
        document.documentElement.removeAttribute('aria-busy');
      });
  }

  function schedule(form) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      apply(form);
    }, DEBOUNCE_MS);
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-nd-facet-search]')) return;
    var form = e.target.closest('[data-nd-facets]');
    if (!form) return;
    if (e.target.type === 'number') return;
    schedule(form);
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-nd-facet-search]')) return;
    var query = e.target.value.trim().toLocaleLowerCase('de');
    e.target.closest('.nd-facets__body').querySelectorAll('li').forEach(function (item) {
      item.hidden = !item.textContent.toLocaleLowerCase('de').includes(query);
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareFilters);
  else prepareFilters();
  window.matchMedia('(min-width: 900px)').addEventListener('change', prepareFilters);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nd-facets]');
    if (!form) return;
    e.preventDefault();
    apply(form);
  });

  window.addEventListener('popstate', function () {
    if (!document.querySelector(ROOT)) return;
    window.location.reload();
  });
})();
